module.exports = {"id":"161648","name":"Hatem Ben Arfa","rating":"79","photo":"./data/images/photos/1/161648.png","club":{"name":"Paris","logo":"./data/images/clubs/Paris.png"},"positions":["MOC","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HatemBenArfa0.json
// module id = 1707
// module chunks = 0